//#region types
import { AuthEnums } from "models/enums";
//#endregion
//#region components
import { useCheckRelations } from "components/common";
//#endregion

const useSIEFilesPermissions = () => {
  const { hasRelation, getIsRevisor } = useCheckRelations();

  const hasSieFileViewPermissions = () => {
    return hasRelation(AuthEnums.PersonCompanyRelationType.Reports) || getIsRevisor();
  };

  return {
    hasSieFileViewPermissions,
  };
};

export default useSIEFilesPermissions;
